import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, delay, map, mergeMap, tap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { ToastrConfigs } from "../../@core/data/toastr-config";
import { NbToastrService } from "@nebular/theme";
import { SagaService } from "../../@core/data/saga/saga.service";
import {
  EmployeesError,
  EmployeesLoaded,
  EmployeesLoading,
  EmployeesRequested,
} from './employees.actions';
import {EmployeesService} from "../../@core/data/employees/employees.service";

@Injectable()
export class EmployeesEffects {
  constructor(
    private actions$: Actions,
    private toastrService : NbToastrService,
    private employeesService: EmployeesService
  ) {}

  requestEmployees$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeesRequested),
      mergeMap(() =>
        concat(
          of(EmployeesLoading()),
          this.employeesService.getEmployees().pipe(
            map((response: any) => EmployeesLoaded({ employees: response?.data })),
            catchError((error: any) => of(EmployeesError()))
          )
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EmployeesError),
        tap(() => {
          this.toastrService.show(`Lista angajatilor nu a putut fi încărcată!`, `Eroare`, ToastrConfigs.danger);
        })
      ),
    { dispatch: false }
  );
}
